var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { staticClass: "price h1 d-inline-block" }, [
      _c(
        "span",
        { ref: "variationTotalPrice", attrs: { content: _vm.priceAll } },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm._f("currency")(_vm.priceAll)) +
              "\n        "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-inline-block base-price text-muted my-3 vatBox ml-2" },
      [
        _c(
          "span",
          { staticClass: "vat text-muted" },
          [
            _vm.variation.unit && _vm.variation.unit.unitOfMeasurement == "MTR"
              ? _c("span", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate("Snaply5::Template.singleUnitSlang")
                      ) +
                      "\n                "
                  ),
                  _vm.variation.variation.minimumOrderQuantity == 0.5
                    ? _c("span", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.variation.variation.minimumOrderQuantity
                            ) +
                            "\n                "
                        )
                      ])
                    : _c("span", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.variation.unit.content) +
                            "\n                "
                        )
                      ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.variation.unit.names.name) +
                      "\n            "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.shownet
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.singleItemExclVAT")
                      ) +
                      "\n            "
                  )
                ]
              : [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.singleItemInclVAT")
                      ) +
                      "\n            "
                  )
                ]
          ],
          2
        ),
        _vm._v(" "),
        _vm.variation.variation.mayShowUnitPrice
          ? _c("span", [
              _vm._v(
                "\n            (" +
                  _vm._s(
                    _vm.$translate("Ceres::Template.singleItemUnitPrice")
                  ) +
                  " "
              ),
              _c("span", { staticClass: "base-price-value" }, [
                _vm._v(_vm._s(_vm.baseprice))
              ]),
              _vm._v(")\n        ")
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "choosen-colors",
        on: {
          click: function($event) {
            return _vm.showSideBar()
          }
        }
      },
      [
        _vm.fullItems.length > 0
          ? _vm._l(_vm.fullItems, function(color, index) {
              return index <= 3
                ? _c("div", [
                    _c("div", [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: {
                          src: color.data.images.all[0].urlPreview,
                          alt: color.data.texts.name1,
                          title: color.data.texts.name1
                        }
                      })
                    ])
                  ])
                : _vm._e()
            })
          : [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3)
            ],
        _vm._v(" "),
        _vm._m(4)
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-xl-7" }, [
        _c(
          "div",
          {
            staticClass:
              "btn btn-block btn-primary btn-danger d-flex align-items-center justify-content-center",
            on: {
              click: function($event) {
                return _vm.showSideBar()
              }
            }
          },
          [
            _vm.fullItems.length > 0
              ? _c("i", { staticClass: "fa fa-check" })
              : _c("i", { staticClass: "fa fa-spin fa-circle-o-notch" }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "flex-fill" },
              [
                _vm.fullItems.length > 0
                  ? [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$translate(
                              "Snaply5::Template.singleChooseFromXColors",
                              { colorCount: _vm.fullItems.length }
                            )
                          ) +
                          "\n                    "
                      )
                    ]
                  : [
                      _vm._v(
                        "\n                         " +
                          _vm._s(
                            _vm.$translate(
                              "Snaply5::Template.singleColorLoading"
                            )
                          ) +
                          "\n                    "
                      )
                    ]
              ],
              2
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-color-select" }, [
      _c("div", { staticClass: "sidebar-header" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "title mb-lg-2" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(
                    _vm.$translate("Snaply5::Template.singleColorSelect")
                  ) +
                  "\n                    "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-6 text-right",
              on: {
                click: function($event) {
                  return _vm.closeColors()
                }
              }
            },
            [_c("i", { staticClass: "snaply-close blue" })]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-2 mb-lg-3 align-items-center" }, [
          _c("div", { staticClass: "col-12 col-lg-6 mb-2" }, [
            _c("div", { staticClass: "sub-title blue" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(
                    _vm.$translate("Snaply5::Template.singleColorMultiSelect")
                  ) +
                  "\n                    "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-7 col-lg-6" }, [
            _c(
              "a",
              {
                staticClass:
                  "btn btn-outline-primary btn-block rounded mb-3 mb-lg-0",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    return _vm.selectAll()
                  }
                }
              },
              [
                _vm.buyAll == false
                  ? [
                      _vm._v(
                        "\n                             " +
                          _vm._s(
                            _vm.$translate(
                              "Snaply5::Template.singleColorSelectAll"
                            )
                          ) +
                          " "
                      ),
                      _c("i", { staticClass: "fa fa-angle-right" })
                    ]
                  : [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$translate(
                              "Snaply5::Template.singleColorDeSelectAll"
                            )
                          ) +
                          " "
                      ),
                      _c("i", { staticClass: "fa fa-angle-right" })
                    ]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.fullItems.length > 30
            ? _c(
                "div",
                {
                  staticClass:
                    "col-5 col-lg-12 p-l-0 pl-lg-3 mt-lg-3 mb-3 mb-lg-0"
                },
                [
                  _c("input", {
                    staticClass: "farb-suche",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$translate(
                        "Snaply5::Template.singleColorSearchPlaceholder"
                      )
                    },
                    on: {
                      keyup: function($event) {
                        return _vm.filterItems($event)
                      }
                    }
                  })
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-items" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.fullItems, function(color) {
            return _c(
              "div",
              {
                staticClass: "col-4 col-md-3 mb-1",
                class: {
                  "d-none": _vm.searchActive && color.searched === false
                }
              },
              [
                _c("div", { staticClass: "variation" }, [
                  _c(
                    "div",
                    { staticClass: "variation-image" },
                    [
                      color.data.stock.net > 0
                        ? [
                            color.active
                              ? _c("i", {
                                  staticClass: "snaply-close",
                                  on: {
                                    click: function($event) {
                                      return _vm.addColor(color)
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            color.data.prices.rrp.price.value >
                            color.data.prices.default.price.value
                              ? [
                                  _c("div", { staticClass: "special-tags" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-offer badge-info"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                      " +
                                            _vm._s(_vm.percent(color)) +
                                            "\n                                    "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "lazy-click-container cursor",
                                on: {
                                  click: function($event) {
                                    return _vm.addColor(color)
                                  }
                                }
                              },
                              [
                                _c("lazy-img", {
                                  staticClass: "wrap-img-fluid",
                                  attrs: {
                                    "image-url":
                                      color.data.images.all[0].urlPreview,
                                    alt: color.data.texts.name2,
                                    title: color.data.texts.name2
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            color.active
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: color.quantity,
                                      expression: "color.quantity",
                                      modifiers: { number: true }
                                    }
                                  ],
                                  attrs: { type: "number" },
                                  domProps: { value: color.quantity },
                                  on: {
                                    change: function($event) {
                                      return _vm.changeInputVal(color)
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        color,
                                        "quantity",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function($event) {
                                      return _vm.$forceUpdate()
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        : [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "lazy-click-container cursor reminder-wrapper",
                                on: {
                                  click: function($event) {
                                    return _vm.addToEmailReminderList(color)
                                  },
                                  "~mouseover": function($event) {
                                    return _vm.$store.dispatch(
                                      "loadComponent",
                                      "email-reminder"
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-envelope" }),
                                _vm._v(" "),
                                _c("lazy-img", {
                                  staticClass: "wrap-img-fluid",
                                  attrs: {
                                    "image-url":
                                      color.data.images.all[0].urlPreview,
                                    alt: color.data.texts.name2,
                                    title: color.data.texts.name2
                                  }
                                })
                              ],
                              1
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "name" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(color.data.texts.name2)
                    ),
                    _c("br")
                  ])
                ])
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-footer" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "text-center" }, [
              _c("span", { staticClass: "sidebar-item-count" }, [
                _vm._v(_vm._s(_vm.itemCount))
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$translate("Snaply5::Template.singleColorItemSum")
                  ) +
                  " "
              ),
              _c("span", { staticClass: "sidebar-price-count" }, [
                _vm._v(_vm._s(_vm._f("currency")(_vm.priceAll)))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "btn btn-primary btn-danger btn-block select-colors",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.colorsToCart()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "snaply-shopping-bag" }),
                    _vm._v(
                      "\n                          " +
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.singleItemAddToBasket"
                          )
                        ) +
                        "\n                      "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.$store.state.user.userData !== null
                  ? [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn-primary btn ml-2 btnAddtoList d-flex justify-content-center",
                          class: {
                            "disabledAnchor disabled": this.varsToBuy.length < 1
                          },
                          staticStyle: { color: "white" },
                          on: { click: _vm.emitCartSave }
                        },
                        [
                          _c("i", {
                            staticClass: "snaply-like",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ]
                  : [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn-primary btn ml-2 btnAddtoList d-flex justify-content-center",
                          class: {
                            "disabledAnchor disabled": this.varsToBuy.length < 1
                          },
                          staticStyle: { color: "white" },
                          attrs: {
                            "data-testing": "login-select",
                            href: "#login",
                            "data-toggle": "modal"
                          },
                          on: {
                            "~mouseover": function($event) {
                              return _vm.$store.dispatch(
                                "loadComponent",
                                "login-modal"
                              )
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "snaply-like",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ]
              ],
              2
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "color-select-greybg",
      on: {
        click: function($event) {
          return _vm.closeColors()
        }
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lot-more-colors" }, [
      _c("span", { staticClass: "dot" }),
      _vm._v(" "),
      _c("span", { staticClass: "dot" }),
      _vm._v(" "),
      _c("span", { staticClass: "dot" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }